import React from "react";

const Home = () => {
    return (
        <section className="-mt-12 w-full h-screen flex justify-center items-center">
            <div className="text-4xl font-bold text-center space-y-2">
                <div>
                    Welc<span className="gradient-text">o</span>me T<span className="gradient-text">o</span>
                </div>
                <div>
                    Align Dashb<span className="gradient-text">o</span>ard
                </div>
            </div>
        </section>
    );
};

export default Home;
